import React from 'react';
import Example from '../typography-example';
import Dependency from '../dependency';
import styles from './typography.module.scss';

const MIXINS_URL =
  'https://github.com/RaiseMe/raise-ror-webapp/blob/develop/app/assets/stylesheets/components/mixins.scss';

export default class Typography extends React.Component {
  render() {
    return (
      <section className={styles.section}>
        <header>
          <h1 id="typography">Typography</h1>
        </header>
        <p>
          Aptitude typography rules and styles to be used across all Raise Me products. All
          typography rules are contained in <a href={MIXINS_URL}>mixins.scss</a> within the
          stylesheet components directory in the webapp. Aptitude uses Open Sans as its primary font
          of choice and cascades down to web-safe fonts when unable to render.
        </p>
        <pre>
          {`font-family: 'Open Sans', Arial, Helvetica, sans-serif;
color: $n900;`}
        </pre>

        <section className={styles.subsection}>
          <h2>Dependencies</h2>
          <hr />
          <Dependency identifier="classes">
            <h3>
              Class Usage (e.g. <code className={styles.code}>.shared-font.headline</code>)
            </h3>
            @import &apos;./typography.module.scss&apos;;
          </Dependency>

          <Dependency identifier="mixins">
            <h3>
              Mixin Usage (e.g. <code className={styles.code}>@include headline;</code>)
            </h3>
            @import &apos;components/mixins&apos;;
          </Dependency>
        </section>

        <section className={styles.subsection}>
          <h2>Usage</h2>
          <hr />
          <Example klass="headline">
            {`font-size: 24px;
font-weight: 400;
line-height: 1.5;`}
          </Example>

          <Example klass="title">
            {`font-size: 20px;
font-weight: 600;
line-height: 1.5;`}
          </Example>

          <Example klass="subheading">
            {`font-size: 16px;
font-weight: 400;
line-height: 1.5;`}
          </Example>

          <Example klass="body">
            {`font-size: 14px;
font-weight: 400;
line-height: 1.5;`}
          </Example>

          <Example klass="caption">
            {`font-size: 12px;
font-weight: 400;
line-height: 1.5;`}
          </Example>
        </section>

        <section className={styles.subsection}>
          <h2>Display Fonts</h2>
          <hr />
          <Example klass="display-3">
            {`font-size: 56px;
font-weight: 600;
line-height: 1.2;
letter-spacing: -1px;`}
          </Example>

          <Example klass="display-2">
            {`font-size: 44px;
font-weight: 600;
line-height: 1.2;
letter-spacing: -1px;`}
          </Example>

          <Example klass="display-1">
            {`font-size: 32px;
font-weight: 600;
line-height: 1.5;
letter-spacing: -1px;`}
          </Example>
        </section>

        <section className={styles.subsection}>
          <h2>Formatting</h2>
          <hr />
          <Example klass="bold">font-weight: 600;</Example>

          <Example klass="caps">
            {`text-transform: uppercase;
letter-spacing: 1px;`}
          </Example>

          <Example klass="italic">font-style: italic;</Example>
        </section>
      </section>
    );
  }
}
